// -----------------------------------------------------------------------------
// Categorized logging (template pattern).
//
// A thin, static, console-backed logger shared between the website (Next.js) and
// the app (Overwolf shell). The API mirrors the base-architecture template's
// LoggerService:
//
//   const logger = LoggerService.getCategory('Background'); // one per class
//   logger.info('App version:', version);
//
// `info`/`warn`/`error` all log unconditionally, each tagged with its category.
// -----------------------------------------------------------------------------

export interface CategoryLogger {
  info(...args: unknown[]): void;
  warn(...args: unknown[]): void;
  error(...args: unknown[]): void;
}

// -----------------------------------------------------------------------------
export class LoggerService {
  // ---------------------------------------------------------------------------
  /** Get a named category logger; the convention is one per class. */
  public static getCategory(category: string): CategoryLogger {
    const prefix = `[${category}]`;
    return {
      info: (...args: unknown[]) => {
        console.log(prefix, ...args);
      },
      warn: (...args: unknown[]) => {
        console.warn(prefix, ...args);
      },
      error: (...args: unknown[]) => {
        console.error(prefix, ...args);
      }
    };
  }
}
